<template>
    <CContainer>
      <h3 class="d-inline-block">Usuarios</h3>
      <CSpinner color="dark" size="sm" class="ml-3 d-inline-block" v-if="loadingGeneral"/>
      <CCard class="mt-4">
        <CCardBody class="p-3">
          <CRow>
            <CCol class="col-sm-7">
              <CInput 
                class="col-sm-9 d-inline-block"
                label="Buscar:"
                :value.sync="searchWord"
              />
              <CButton 
                class="d-inline-block" 
                color="info" 
                variant="outline"
                @click="getData(1, searchWord)">
                <CIcon name="cil-search" />
              </CButton>
              <CButton 
                v-if="false"
                class="d-inline-block ml-2" 
                color="success" 
                variant="outline"
                @click="addUser()">
                <CIcon name="cil-plus" />
              </CButton>
            </CCol>
            <CCol>
              <h5 class="mt-4 pt-2">{{ selectedUserName }}</h5>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-sm-7">
              <CDataTable
                :items="users"
                :fields="fieldsUser"
                :items-per-page="itemsPerPage"
                hover>
                <template #usuario="{item}">
                  <td>
                    <h4>{{ item.nombre_Usuario }}</h4>
                    <div>
                      <CIcon name="cil-user"/>
                      {{ item.usuario }}
                    </div>
                  </td>
                </template>
                <template #informacion="{item}">
                  <td>
                    <div>
                      <CIcon v-if="item.estado == 'A'" name="cil-smile" class="text-success mr-2" />
                      <CIcon v-if="item.estado == 'I'" name="cil-mood-very-bad" class="text-danger mr-2" />
                      <span v-if="item.estado == 'A'">Activo</span>
                      <span v-if="item.estado == 'I'">Inactivo</span>
                    </div>
                    <div>
                      <CIcon name="cil-history" class="mr-1" />
                      {{ moment(item.ultimo_Ingreso).format('DD/MM/YYYY - HH:mm') }}
                    </div>
                  </td>
                </template>
                <template #action="{item}">
                  <td>
                    <a 
                      href="#" 
                      class="mb-2" 
                      @click="getDataDependencies(item.id_UsuarioInternet, item.nombre_Usuario)">
                      <CIcon name="cil-address-book" class="text-dark"/>
                    </a>
                    <a 
                      v-if="false"
                      href="#" 
                      class="mb-2 ml-2" 
                      @click="deleteUser(item.id_UsuarioInternet)">
                      <CIcon name="cil-trash" class="text-danger"/>
                    </a>
                    <a 
                      v-if="false"
                      href="#" 
                      class="mt-1 ml-2" 
                      @click="addDependency(item.id_UsuarioInternet)">
                      <CIcon name="cil-library-add" class="text-success"/>
                    </a>
                  </td>
                </template>
              </CDataTable>
              <CElementCover v-show="loading"/>
              <CPagination
                :activePage.sync="page"
                :pages="pageCount"
                size="sm"
                align="center"
                @update:activePage="(value, a) => getData(value, searchWord)"
              />
            </CCol>
            <CCol class="col-sm-5">
              <CDataTable
                :items="dependencies"
                :fields="fieldsDependency"
                :items-per-page="itemsPerPage"
                hover 
                pagination>
                <template #dependencia="{item}">
                  <td>
                    <h4>{{ item.dependencia }}</h4>
                    <div>
                      <strong>{{ item.codigo }}</strong>
                    </div>
                    <div>
                      {{ item.responsable }}
                    </div>
                  </td>
                </template>
                <template #action="{item}">
                  <td>
                    <a 
                      href="#" 
                      class="mb-2" 
                      @click="deleteDependencyUser(item.id_DependenciaUsuario)">
                      <CIcon name="cil-trash" class="text-danger"/>
                    </a>
                  </td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CContainer>
</template>

<script>
  import moment from 'moment'
  import { formatter } from '../../general'
  import { dataGridUsuarios } from "@/apis/security";
  import { dataGridDependenciasUsuario } from '../../apiDataGrids'
  import { crudDependenciaUsuario } from '../../apiCRUD'

  const fieldsUser = [
    { key: 'usuario', _style:'text-align:center;' },
    { key: 'informacion', label: 'Información', _style:'text-align:center;' },
    { key: 'action', label: '', _style:'text-align:center;' }
  ]
  const fieldsDependency = [
    { key: "dependencia", _style: "text-align: center;" },
    { key: "action", label: "", _style: "text-align: center;" }
  ]

  export default {
    name: 'Users',
    data () {
      return {
        formatter,
        moment,
        loading: false,
        loadingGeneral: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: '',
        users:[],
        fieldsUser,
        selectedUserName: '',
        dependencies: [],
        fieldsDependency
      }
    },
    methods: {
      async getData(page, search) {
        try {
          this.loading = true
          const { count, results } =  await dataGridUsuarios(
            this,
            page,
            search,
            'cliente',
            this.$store.state.user.data.id_Directorio
          )
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.users = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async getDataDependencies(idUser, userName) {
        try {
          this.loadingGeneral = true
          const results = await dataGridDependenciasUsuario(
            this,
            idUser
          )
          this.dependencies = results
          this.selectedUserName = userName
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos...",
            show: 5
          })
        } finally {
          this.loadingGeneral = false
        }
      },
      async deleteDependencyUser(idDependecyUser) {
        this.loadingGeneral = true
        
        try {
          await crudDependenciaUsuario(this, "delete", idDependecyUser, null)
          this.getDataDependencies()
          this.selectedUserName = ""
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al borrar el registro...",
            show: 5
          })
        } finally {
          this.loadingGeneral = false
        }
      }
    },
    async mounted(){
      await this.getData(this.page)
    }
  }
</script>